import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import api from "../../Utils/api";
import Select from "react-select";

export default function AddNewLocation() {
  const user = useSelector((state) => state.user.user);
  const [name, setName] = useState("");
  const [area, setArea] = useState("");
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyID, setCompanyID] = useState("");

  useEffect(() => {
    if (user && user.deputyAccessLevel === "system_administrator") {
      fetchCompanies();
    } else if (user && user.deputyAccessLevel === "company_manager") {
      // Auto-set company for company managers
      setCompanyID(user.companyID);
    }
  }, [user]);

  const fetchCompanies = async () => {
    try {
      const response = await api.get("/company");
      if (response.data.success) {
        // Only show active (non-archived) companies
        setCompanies((response.data.companies || []).filter(company => !company.archive));
      }
    } catch (error) {
      console.error("Failed to fetch companies:", error);
    }
  };

  const navigate = useNavigate();

  const submitLocation = async () => {
    // Validate inputs
    if (!name || !area) {
      toast.warn("Please fill in all required fields correctly!");
      return;
    }
    const res = await api.post("/location", {
      name,
      area,
      companyID: companyID || null,
    });

    if (res.data.success) {
      toast.success(res.data.message);
      navigate("/locations");
    } else if (res.data.status === "warn") {
      toast.warn(res.data.message);
    } else {
      toast.error("Failed to add location");
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6 max-w-2xl m-24 mx-auto border border-[#d8d7dc]">
      <h2 className="text-[24px] font-semibold text-gray-900 mb-2">
        Add new location
      </h2>
      <p className="text-sm text-gray-600 mb-6">
        A location is a place where business operations take place.
      </p>
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          submitLocation();
        }}
      >
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Location Name <span className="text-red-500">*</span>
          </label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full border text-gray-800 rounded px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-gray-300"
            placeholder="The Corner Cafe"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Area <span className="text-red-500">*</span>
          </label>
          <input
            value={area}
            onChange={(e) => setArea(e.target.value)}
            className="w-full border rounded px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-gray-300"
            placeholder="Downtown, Business District, etc."
            required
          />
        </div>

        {/* Company - Only for system administrators */}
        {user && user.deputyAccessLevel === "system_administrator" && (
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Company
            </label>
            <Select
              name="company"
              placeholder="Select a Company"
              className="basic-multi-select w-full cursor-pointer"
              classNamePrefix="select"
              options={companies}
              value={selectedCompany}
              onChange={(option) => {
                setSelectedCompany(option);
                setCompanyID(option ? option._id : "");
              }}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option._id}
              isClearable={true}
              styles={{
                control: (provided) => ({
                  ...provided,
                  borderColor: "#d1d5db",
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: "#9ca3af",
                  },
                }),
              }}
            />
          </div>
        )}

        <div className="flex justify-end gap-4 mt-6">
          <button
            type="button"
            onClick={() => navigate("/locations")}
            className="px-4 py-2 rounded text-white bg-gray-500 hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 rounded text-white bg-gray-700 hover:bg-[#4c389d]"
          >
            Add Location
          </button>
        </div>
      </form>
    </div>
  );
}
